/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Accordion from './accordion';

Fancybox.bind('[data-fancybox]');
// Youtube/Vimeo popups
Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		done: (fancybox) => {
			const transcription = fancybox.options.triggerEl.nextElementSibling;

			if (transcription && transcription.classList.contains('video-transcription')) {
				const boxContent = fancybox.container.querySelector('.fancybox__content');

				if (!boxContent.querySelector('.video-transcription')) {
					const transcriptionClone = transcription.cloneNode(true);
					transcriptionClone.classList.remove('hidden');
					transcriptionClone.classList.add('absolute', 'w-full', 'top-full', 'left-0');
					boxContent.classList.add('relative');
					boxContent.append(transcriptionClone);
				}
			}

			fancybox.container.querySelector('.is-close-btn').focus();
			fancybox.container.querySelector('iframe').setAttribute('title', 'Play Video');

			// accordions
			const accordions = document.querySelectorAll('[data-details]');
			if (accordions.length) {
				accordions.forEach((accordion) => {
					new Accordion(accordion);
				});
			}
		},
	},
});

// Default WP Gallery popups
Fancybox.bind('.popup-gallery', {
	Thumbs: {
		type: 'classic',
	},
	on: {
		done: (fancybox) => {
			fancybox.container.querySelector('[data-fancybox-close]').focus();
		},
	},
});
